// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { Alert, Button, Col, Row } from 'angieslist-react-components';
import { analytics, urlCatalog, tracker } from 'angieslist-app-platform';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import CategoryAutocomplete from 'angieslist-app-platform/lib/browser/autocomplete/categoryAutocomplete/CategoryAutocomplete';
import { reduxForm, Form, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import serviceCategoriesAnalytics from './serviceCategoriesAnalytics';
import * as categoriesActions from '../../../../app/common/categories/categoriesActions';

const styles = {
  buttonStyle: {
    margin: '.5em',
    borderRadius: '1.5em',
  },
};

type State = {
    categoriesToAdd: Array<any>,
    error?: string
  }

/* eslint react/prefer-stateless-function: 0 */
export class ServiceCategoriesFormComponent extends React.Component<*, State> {
  constructor(props: any) {
    super(props);
    this.addServiceCategories = this.addServiceCategories.bind(this);
    this.state = {
      categoriesToAdd: [],
    };
  }

  state: State;

  componentWillMount() {
    const { getServiceProviderCategories, serviceProviderId } = this.props;
    getServiceProviderCategories(serviceProviderId);
  }

  props: {
    handleSubmit: (submitFn: (values: any) => Promise<any>) => void,
    serviceProviderId: number,
    error: any,
    welcomeStore: any,
    addCategoriesToServiceProvider:
      (serviceProviderId: number, categoriesToAdd: Array<any>) => Promise<any>,
    getServiceProviderCategories: (serviceProviderId: number) => Promise<any>
  }

  // Need to explicitly define this as a function; method notation causes flow errors
  addServiceCategories: any | (() => Promise<void | any>) = () => {
    const { serviceProviderId, addCategoriesToServiceProvider } = this.props;
    return addCategoriesToServiceProvider(serviceProviderId, this.state.categoriesToAdd)
      .then(() => {
        tracker.track('Item Clicked', {
          serviceProviderId,
          description: 'Welcome Service Categories',
          activityLocation: 'SP : Welcome Service Categories',
          userId: _.get(this, 'props.user.userInfo.response.userId'),
        });
      })
      .catch(() => {
        const errorMessage = (<span>There was a problem adding service categories.  Please contact us at <a id="welcome-view--add-service-categories--error-link" href={urlCatalog.global.businessCenterPhone()}>{urlCatalog.global.businessCenterPhoneText()}</a> for assistance.</span>);
        throw new SubmissionError({ _error: errorMessage });
      });
  }

  render(): Element<"div"> {
    const { handleSubmit, error, welcomeStore } = this.props;
    const isLoading = _.get(welcomeStore, 'categoriesToAdd.isLoading');
    const currentCategories = _.get(welcomeStore, 'serviceProviderCategories.response.categories');
    const categoryAutocompleteProps = {
      id: 'welcome-service-categories--add-category-autocomplete',
      placeholder: 'Start typing and select a category',
      autoFocus: false,
      iconLocation: 'none',
      requireSelection: true,
      clearAfterSelection: true,
      autocompleteEventHandler: (event) => {
        const newCategory = {
          name: event.displayText,
          id: event.categoryId,
        };
        if (_.find(currentCategories, { id: event.categoryId })) {
          this.setState({
            error: 'This category has already been added to your profile.',
          });
        } else {
          this.setState({
            categoriesToAdd: _.uniqBy([...this.state.categoriesToAdd, newCategory], 'id'),
            error: '',
          });
        }
      },
    };
    return (
      <div>
        <Form onSubmit={handleSubmit(this.addServiceCategories)}>
          <If condition={error}>
            <Alert bsStyle="danger">{error}</Alert>
          </If>
          <If condition={this.state.error}>
            <Alert bsStyle="danger">{this.state.error}</Alert>
          </If>
          <Row>
            <Col xs={12}>
              <h5>Show members the services you offer</h5>
              <p>
                Let us know what other services you offer in addition to the service category
                listed below.
              </p>
            </Col>
          </Row>
          <Loader
            loading={isLoading}
            element={
              <Row className="category-row text-center">
                <i className="icon icon-load icon-spin icon-3x text-primary" />
              </Row>
          }
          >
            <Row>
              <Col xs={12}>
                <CategoryAutocomplete categoryAutocompleteDetails={categoryAutocompleteProps} />
                <div>
                  {_.map(currentCategories, category => (
                    <Button
                      className="existing-category"
                      style={styles.buttonStyle}
                      key={category.id}
                      id={`category-management--add-category--existing-category-${category.id}`}
                      bsStyle="primary-office"
                      bsSize="xsmall"
                      flat
                      disabled
                    >{category.name}
                    </Button>
                    ))}
                  {_.map(this.state.categoriesToAdd, category => (
                    <Button
                      className="new-category"
                      style={styles.buttonStyle}
                      key={category.id}
                      id={`category-management--add-category--new-category-${category.id}`}
                      bsStyle="primary-office"
                      bsSize="xsmall"
                      flat
                      onClick={() => {
                          this.setState({
                            categoriesToAdd: _.filter(
                              this.state.categoriesToAdd,
                              c => c.id !== category.id,
                            ),
                            error: '',
                          });
                        }}
                    >{category.name}<i className="icon icon-close" style={{ marginLeft: '0.7em' }} />
                    </Button>))}
                </div>
              </Col>
            </Row>
          </Loader>
        </Form>
      </div>
    );
  }
}

export default (compose(
  reduxForm({
    form: 'welcomeServiceCategoriesForm',
    destroyOnUnmount: false,
  }),
  connect(
    state => ({
      welcomeStore: state.welcome,
      user: state.user,
    }),
    {
      ...categoriesActions,
    },
  ),
  analytics({
    ruleset: serviceCategoriesAnalytics,
  }),
  pure,
)(ServiceCategoriesFormComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/ServiceCategoriesForm.js